export default "__VITE_ASSET__BV7PR9zt__"